module.exports = __webpack_public_path__ + "img/Talk Graphic 11 - Solo Breakfast.549b7bb7.png";